import { Controller } from "@hotwired/stimulus";
import {
  MINIMUM_ACCURACY,
  WATCH_FRESH_MAX_AGE_MS,
} from "../route_datapoints/form_controller.js";

export function gpsStatusFor(position, now = Date.now()) {
  if (!position?.coords) return "acquiring";
  if (now - position.timestamp > WATCH_FRESH_MAX_AGE_MS) return "acquiring";
  return position.coords.accuracy <= MINIMUM_ACCURACY ? "ready" : "weak";
}

// Connects to data-controller="sanitation-forms--gps-calibration"
export default class extends Controller {
  static targets = ["acquiring", "weak", "ready", "accuracy", "accuracyValue"];
  static values = { confirmMessage: String };

  connect() {
    this.lastPosition = null;
    this.boundGuardSubmit = this.guardSubmit.bind(this);
    // Capture phase on the wrapper runs before the form's own
    // sanitation-forms--first-step#submit listener, regardless of binding order.
    this.element.addEventListener("submit", this.boundGuardSubmit, {
      capture: true,
    });

    if (navigator.geolocation) {
      this.geoWatchId = navigator.geolocation.watchPosition(
        (position) => {
          this.lastPosition = position;
          this.renderStatus();
        },
        (error) => {
          console.warn("GPS calibration watch error:", error);
          this.lastPosition = null;
          this.renderStatus();
        },
        { enableHighAccuracy: true, maximumAge: 0, timeout: 120000 },
      );
    }
  }

  disconnect() {
    this.element.removeEventListener("submit", this.boundGuardSubmit, {
      capture: true,
    });
    if (this.geoWatchId != null) {
      navigator.geolocation.clearWatch(this.geoWatchId);
      this.geoWatchId = null;
    }
  }

  guardSubmit(event) {
    if (gpsStatusFor(this.lastPosition) === "ready") return;

    if (!confirm(this.confirmMessageValue)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  renderStatus() {
    const status = gpsStatusFor(this.lastPosition);
    this.acquiringTarget.classList.toggle("hidden", status !== "acquiring");
    this.weakTarget.classList.toggle("hidden", status !== "weak");
    this.readyTarget.classList.toggle("hidden", status !== "ready");

    const accuracy = this.lastPosition?.coords?.accuracy;
    this.accuracyTarget.classList.toggle("hidden", accuracy == null);
    if (accuracy != null) {
      this.accuracyValueTarget.textContent = `${Math.round(accuracy)} m`;
    }
  }
}
